import { useConditional } from "../../core/hooks/useConditional";
import { Modal } from "../../core/ui/Modal";
import { Table } from "../../core/ui/Table";
import { Icon } from "../../core/ui/icons";
import { first, last } from "../../core/utils/array";
import { DateCol } from "../../layout/TableCells";
import { Address, AddressType, getAddressTypeName } from "../../types";
import { EditTrackedItem } from "./EditTrackedItem";
import { formatData } from "./Format";
import { HistoryModal } from "./HistoryModal";
import { TrackedItemDisplay } from "./TrackedItemDisplay";
import { parseTrackedItems } from "./parseTrackedItem";

export function AddressDisplay(props: {
	address: Address,
	singleLine?: boolean,
}) {

	const { address } = props;

	const format = address ? {
		lines: [
			{
				parts: [address.careOf],
			},
			{
				parts: [address.line2],
			},
			{
				parts: [address.street],
			},
			{
				parts: [address.locality, address.state, address.postCode],
				separator: " ",
			},
			{
				parts: [address.country],
			},
		]		
	} : undefined;

	return (
		<div className={"" + (props.singleLine ? "flex flex-wrap gap-5" : "")}>
		{formatData(format)}
		</div>
	);
}

export function AddressCol(props: {
	className?: string,
	getAddress?: (r: any, c: any) => any,
	singleLine?: boolean,
}) {
	return {
		className: props.className,

		title: (c: any) => {
			return "Address";
		},
		
		value: (r: any, c: any) => {
			let address;
			
			if (props.getAddress) {
				address = props.getAddress(r, c);	
			}
			if (!address) address = r;

			if (address.data) {
				if (address.data.addresses) {
					address = last(address.data.addresses);
				} else if (address.data.regOffs) {
					address = last(address.data.regOffs);						
				}
			}

			if (address) {
				return <AddressDisplay address={address} singleLine={props.singleLine} />;
			}
		}	
	};
}

export function Addresses(props: {
	addressType: AddressType,
	addresses: Address[],
}) {

	const addresses = parseTrackedItems(props.addresses);
	const address = first(addresses.active);

	const display = (address && address.locality);

	const addressTypeName = getAddressTypeName(props.addressType);

	const edit = useConditional(() => {
		return (
			<EditTrackedItem
				title={`Edit ${addressTypeName} Address`}

				arr={props.addresses}
				initialValues={address}

				canHaveOnlyOneActive={true}

				form="address"
				formOptions={{
					showEffective: true,
				}}

				onCancel={edit.close}
				onClose={edit.close}
			/>
		)
	});

	const history = useConditional(() => {
		return (
			<HistoryModal
				title={`${addressTypeName} Address History`}
				onClose={history.close}
				items={props.addresses}
				cols={[
					AddressCol({}),
				]}
			/>
		);
	})

	return (
		<TrackedItemDisplay
			title={`${addressTypeName} Address`}
			item={address}
			edit={edit}
			history={history}
		>
			<div><b>{getAddressTypeName(props.addressType)}</b></div>
			<AddressDisplay address={address} />
		</TrackedItemDisplay>
	)
}